<template>
  <div id="app">
    <nav class="navbar sticky-top navbar-expand-lg navbar-light" style="background-color: antiquewhite;">
      <div class="container">
        <a class="navbar-brand" href="/">
          <img src="./assets/site_image_32x32.png" width="32" height="32" class="d-inline-block align-top">
          いらすとや検索
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav">
            <li class="nav-item">
              <router-link class="nav-link" active-class="active" :to="{ name: 'Search', query: { query: '笑顔' } }">検索</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" active-class="active" :to="{ name: 'Guide' }">ガイドライン</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" active-class="active" :to="{ name: 'Contact' }">コンタクト</router-link>
            </li>

            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="http://www.irasutoya.com/" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                いらすとや本家(外部リンク)
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <a class="dropdown-item" href="http://www.irasutoya.com/" target="_blank">トップページ</a>
                <a class="dropdown-item" href="http://www.irasutoya.com/p/terms.html" target="_blank">利用規約</a>
              </div>
            </li>
          </ul>
        </div>

      </div>
    </nav>

    <router-view/>

    <nav class="navbar fixed-bottom navbar-expand-sm navbar-light" style="background-color: antiquewhite;">
      <div class="container">
        <ul class="navbar-nav ml-auto">
          <!-- Go to www.addthis.com/dashboard to customize your tools -->
          <div class="addthis_inline_share_toolbox"></div>
        </ul>
      </div>
    </nav>

  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: 'トップページ',
    titleTemplate: '%s | いらすとや検索(公認ファンサイト)'
  },
  mounted: function () {
    (function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) return
      const js = d.createElement(s)
      js.id = id
      js.src = 'https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v2.11'
      fjs.parentNode.insertBefore(js, fjs)
    }(document, 'script', 'facebook-jssdk'))
  }
}
</script>

<style src="bootstrap/dist/css/bootstrap.min.css"></style>

<style>
body {
  overflow-y:scroll;
}

nav.fixed-bottom {
  height: 44px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue